import style from './styles.module.scss';
import Button from 'components/button';
import NumberInput from 'components/number-input';

interface IFormRequestProps {
  text: string;
  buttonLabel: string;
  isLoading: boolean;
  apartmentNumber: string;
  onClick: () => void;
  onChange: (value: string, key: string) => void;
  onFocusInput?: () => void;
  onBlurInput?: () => void;
}

const FormRequestInSystem = ({
  text,
  buttonLabel,
  isLoading,
  apartmentNumber,
  onClick,
  onChange,
  onFocusInput,
  onBlurInput,
}: IFormRequestProps) => {
  return (
    <div className={style.formRequest}>
      <div className={style.formRequest__container}>
        <form className={style.formRequest__form} onSubmit={(e) => e.preventDefault()}>
          <div className={style.formRequest__text}>
            <p>{text}</p>
          </div>

          <div className={style.formRequest__apartmentNumber}>
            <NumberInput
              mode='apartment'
              type='number'
              label='Номер квартиры'
              value={apartmentNumber}
              placeholder='Например: 15'
              isMainPlaceholder
              onChange={(value) => {
                if (value.length < 6) {
                  onChange(value, 'apartmentNumber');
                }
              }}
              onFocus={onFocusInput}
              onBlur={onBlurInput}
            />
          </div>
        </form>

        <div className={style.formRequest__button}>
          <Button label={buttonLabel} onClick={onClick} loading={isLoading} />
        </div>
      </div>
    </div>
  );
};

export default FormRequestInSystem;
